module.exports = __webpack_public_path__ + "img/carousel-51.e2e0b1b9.jpg";